// ---- Product Tab Switcher ----
document.querySelectorAll('.tabs_div').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.tab_img').forEach(img => img.style.display = 'none');
    const target = document.getElementById('tab_img' + tab.id.replace(/\D/g, ''));
    if (target) target.style.display = 'block';
  });
});

document.querySelectorAll('.tabs_div2').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.tab_img22').forEach(img => img.style.display = 'none');
    const target = document.getElementById('tab_img' + tab.id.replace(/\D/g, ''));
    if (target) target.style.display = 'block';
  });
});
